import React, { Component } from "react";
import Carousel from "nuka-carousel";
import "./TestimonialCarousel.css";

function DemoCarousel() {
    return (
        <div id="testimonialCarousel">
        <Carousel autoplay="true" wrapAround={true} renderCenterLeftControls={({ previousSlide }) => (
            <button onClick={previousSlide} className="preBtn">
                &lsaquo;
            </button>
        )}
            renderCenterRightControls={({ nextSlide }) => (
                <button onClick={nextSlide} className="nextBtn">
                    &rsaquo;
                </button>
            )}>
            <div className="nuka-box">
                <div className="testimonial-row row1">
                    <div className="testimonial-box">
                        <img src="images/SecurityInternship/Purnita-Chakrabarty.png" alt="person" className="testimonial-pic" />
                        <h3>Purnita Chakrabarty</h3>
                    </div>
                </div>
                <div className="testimonial-row row2">
                    <div className="testimonial-box">
                        <img src="images/SecurityInternship/Open-quote.png" alt="person" className="left-quote" />
                        <p>Being a part of the Accenture Security Internship Program has been an enriching experience for me. My buddy, learning team members, and other associated members have been supportive. Learning the work culture of Accenture and getting hands-on experience has been nothing short of amazing. </p>
                        <p>I’m looking forward to being part of this wonderful Accenture team.</p>
                        <img src="images/SecurityInternship/Close-quote.png" alt="person" className="right-quote" />
                    </div>
                </div>
            </div>
            <div className="nuka-box">
                <div className="testimonial-row row1">
                    <div className="testimonial-box">
                        <img src="images/SecurityInternship/Riya-Bhattacharya.png" alt="person" className="testimonial-pic" />
                        <h3>Riya Bhattacharya</h3>
                    </div>
                </div>
                <div className="testimonial-row row2">
                    <div className="testimonial-box">
                        <img src="images/SecurityInternship/Open-quote.png" alt="person" className="left-quote" />
                        <p>This internship has been a great experience for me. I had been brimming with excitement when I got the Internship offer letter. I have learned so much here, and it has helped boost my confidence in my subject. I’ve always wanted to be in the Cybersecurity field, and getting an opportunity at Accenture as one of the first Security intern’ batches is an honor and privilege. I hope to learn more moving forward, and I really enjoyed it.</p>
                        <img src="images/SecurityInternship/Close-quote.png" alt="person" className="right-quote" />
                    </div>
                </div>
            </div>
            <div className="nuka-box">
                <div className="testimonial-row row1">
                    <div className="testimonial-box">
                        <img src="images/SecurityInternship/Utsav-Ghosh.png" alt="person" className="testimonial-pic" />
                        <h3>Utsav Ghosh</h3>
                    </div>
                </div>
                <div className="testimonial-row row2">
                    <div className="testimonial-box">
                        <img src="images/SecurityInternship/Open-quote.png" alt="person" className="left-quote" />
                        <p>My internship as a trainee in security Delivery Associate at Accenture has been the most rewarding and motivational experience I have ever had. I connected with so many new people and got to learn a lot of things from them. With such empathetic, compassionate and supportive mentors, this experience has helped me in completing my internship. Because of the lessons I learned from my supervisor and colleagues, I am confident that I will continue to grow and develop professionally and in my personal endeavors.</p>
                        <img src="images/SecurityInternship/Close-quote.png" alt="person" className="right-quote" />
                    </div>
                </div>
            </div>

        </Carousel>
        </div>
    );
}

export default DemoCarousel;
